import { ReactKeycloakProvider } from "@react-keycloak/web";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { setLanguageCookie, setTranslations } from "react-switch-lang";
import App from "./App";
import en from "./assets/i18n/en.json";
import fr from "./assets/i18n/fr.json";
import "./index.scss";
import { routes } from "./route/routes";
import ControlledRoute from "./security/controlledRoute";
import keycloak from "./security/keycloak-config";
import { getEffectiveRoutes } from "./security/route";
import NotFound from "./shared/not-found/notFound";
import store from "./store";

setTranslations({ en, fr });
setLanguageCookie();

const Root: React.FC = () => {
  return (
    <ReactKeycloakProvider authClient={keycloak}>
      <Provider store={store}>
        <BrowserRouter basename="/e-learning">
          <App>
            <Switch>
              {getEffectiveRoutes(routes).map(({ path, Component, exact, roles }) => (
                <ControlledRoute key={path} exact={exact} path={`${path}`} roles={roles}>
                  <Component />
                </ControlledRoute>
              ))}
              <Route component={NotFound} />
            </Switch>
          </App>
        </BrowserRouter>
      </Provider>
    </ReactKeycloakProvider>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));
